import { z } from 'zod';

export const UserManagementSchema = z.object({
	id: z.string(),
	username: z.string(),
	name: z.string(),
	email: z.string().nullable(),
	role: z.string().nullable(),
	writable: z.boolean().nullable(),
	banned: z.boolean().nullable(),
	banReason: z.string().nullable(),
	banExpires: z.string().nullable(),
	MaCB: z.string().nullable(),
	maKhoa: z.string().nullable(),
	createdAt: z.string(),
	updatedAt: z.string()
}).strip();

export const CreateUserSchema = z.object({
	username: z.string().min(2, 'Tên đăng nhập phải có ít nhất 2 ký tự'),
	email: z.string().email('Email không hợp lệ').optional().nullable().or(z.literal('')),
	name: z.string().min(1, 'Tên không được để trống'),
	password: z.string().min(8, 'Mật khẩu phải có ít nhất 8 ký tự').optional().nullable().or(z.literal('')),
	role: z.enum(['user', 'manager', 'admin']).default('user'),
	writable: z.boolean().optional(),
	maKhoa: z.string().optional().nullable().or(z.literal('')),
	MaCB: z.string().optional().nullable().or(z.literal(''))
}).strip();

export const UpdateUserSchema = z.object({
	email: z.string().email('Email không hợp lệ').optional().nullable().or(z.literal('')),
	name: z.string().min(1, 'Tên không được để trống').optional(),
	role: z.enum(['user', 'manager', 'admin']).optional(),
	writable: z.boolean().optional(),
	maKhoa: z.string().optional().nullable().or(z.literal('')),
	MaCB: z.string().optional().nullable().or(z.literal('')),
	banned: z.boolean().optional(),
	banReason: z.string().optional().nullable().or(z.literal('')),
	banExpires: z.string().datetime().optional().nullable().or(z.literal(''))
}).strip();

export const ResetPasswordSchema = z.object({
	password: z.string().min(8, 'Mật khẩu phải có ít nhất 8 ký tự')
}).strip();

export const UserListQuerySchema = z.object({
	page: z.number().int().min(1).default(1),
	limit: z.number().int().min(1).max(100).default(20),
	search: z.string().optional(),
	role: z.enum(['user', 'manager', 'admin']).optional(),
	banned: z.boolean().optional()
}).strip();

export const FacultyOptionSchema = z.object({
	maKhoa: z.string(),
	tenKhoa: z.string(),
}).strip();

// Combined form data covering create, edit, view, and reset-password scenarios
export const UserFormDataSchema = CreateUserSchema.partial().merge(
	UpdateUserSchema.partial()
);

export type UserManagement = z.infer<typeof UserManagementSchema>;
export type CreateUserInput = z.infer<typeof CreateUserSchema>;
export type UpdateUserInput = z.infer<typeof UpdateUserSchema>;
export type ResetPasswordInput = z.infer<typeof ResetPasswordSchema>;
export type UserListQuery = z.infer<typeof UserListQuerySchema>;
export type FacultyOption = z.infer<typeof FacultyOptionSchema>;
export type UserFormData = z.infer<typeof UserFormDataSchema>;
